var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWebsite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3233 9.49719C17.3233 13.8344 13.8051 17.3504 9.4659 17.3504C5.12674 17.3504 1.60742 13.8344 1.60742 9.49719C1.60742 5.15997 5.12533 1.64417 9.46484 1.64417C13.8044 1.64417 17.3233 5.16014 17.3233 9.49719ZM15.8946 9.49719C15.8946 5.95415 13.0105 3.07204 9.4652 3.07204C5.91986 3.07204 3.036 5.95485 3.036 9.49719C3.036 13.0395 5.91986 15.9225 9.46484 15.9225C13.0098 15.9225 15.8946 13.0404 15.8946 9.49719Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0371 9.49719C13.0371 13.8344 11.4375 17.3504 9.46525 17.3504C7.49299 17.3504 5.89355 13.8348 5.89355 9.49719C5.89355 5.15961 7.49264 1.64417 9.4649 1.64417C11.4372 1.64417 13.0371 5.16014 13.0371 9.49719ZM11.6084 9.49719C11.6084 5.32397 10.0875 3.07204 9.46525 3.07204C8.84299 3.07204 7.32213 5.32397 7.32213 9.49719C7.32213 13.6704 8.84299 15.9225 9.4649 15.9225C10.0868 15.9225 11.6084 13.6706 11.6084 9.49719Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03613 5.92773H15.8947V7.35561H3.03613V5.92773ZM3.03613 10.925H15.8947V12.3529H3.03613V10.925Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWebsite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/website.cea41422.svg";
export { ForwardRef as ReactComponent };